import React, { useEffect, useState } from 'react';
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { IFormGridProps } from 'library/types/IFormGridProps'
import { SystemGrid, CheckCrossCell, DateCell } from 'library'
import { BooleanFilterMenu } from '../../library/grid/SystemGridColumnMenuPresets';
import { SystemActionCell } from '../../library/grid/SystemActionCell';

const CenteredHeaderCell = (props) => {
    return (
        <span className={'TextCenter'}>
            {props.title}
        </span>
    );
};
const OpportunityItems = (props: IFormGridProps) => {
    const url = "/Opportunity/";

    const [counter, setCount] = React.useState(1500);

    const RefreshGrid = () => {
        setTimeout(() => {
            setCount(counter + 1);
        }, 500)
    }

    /**
     * @author:Sanju Bishnoi
     * @description: format currency for the amount.
     */
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });

    useEffect(() => {
        document.body.classList.add("opportunity-dashboard");
        var table = document.querySelector('.k-grid-content');
        table.style.height = (document.body.scrollHeight -190)+ "px";
    }, [])

    return <SystemGrid onRowClick={props.onRowClick} pageable={false} dataSource={url} refresh={props.refresh + counter} pageSize={1000}>
        <Column key={1} field="Name" title="Opportunity Name" width="300px" />
        <Column key={2} field="OpportunityType" title="Opportunity Type" width="200px" />
        <Column key={3} field="BDOffice" title="BD Office" width="200px" />
        <Column key={4} field="SolicitationNo" title="Solicitation No." width="200px" />
        <Column key={5} field="PoP" title="PoP" width="200px" />
        <Column key={6} title="Estimated Contract Value" width="200px" cell={(item) => {
            return (<><td>{item.dataItem.EstimatedContractTotal ? formatter.format(item.dataItem.EstimatedContractTotal) : null}</td></>)
        }} />
        <Column key={7} title="Estimated Profit Value" width="200px" cell={(item) => {
            return (<><td>{item.dataItem.EstimatedProfitTotal ? formatter.format(item.dataItem.EstimatedProfitTotal) : null}</td></>)
        }} />
        <Column key={8} field="ProposalDueDate" title="Proposal Due Date" cell={DateCell} filter={"date"} width="200px" />
        <Column key={9} field="RFPReleaseDate" title="RFP Release Date" cell={DateCell} filter={"date"} width="200px" />
        <Column key={10} field="ContractStartDate" title="Contract Start Date" cell={DateCell} filter={"date"} width="200px" />
        <Column key={11} field="BidDecisionDate" title="Bid Decision Date" cell={DateCell} filter={"date"} width="200px" />
        <Column key={12} field="WorkflowStatus" title="Workflow Status" width="200px" />
        <Column key={13} field="OpportunityStatus" title="Opportunity Status" width="200px" />
        <Column key={14} field="PrimaryNAICS" title="NAICS" width="300px" />
    </SystemGrid>
}

export default OpportunityItems